import React from 'react'
import styles from './MicrositePlacementBadge.module.css'

/**
 * MicrositePlacementBadge
 * Script injection placement: HEAD / BODY_START / BODY_END.
 *
 * Usage:
 *   <MicrositePlacementBadge value={row.placement} />
 */
const LABELS = {
    HEAD: '<head>',
    BODY_START: '<body> start',
    BODY_END: '<body> end'
}

const MicrositePlacementBadge = ({ value }) => (
    <span className={styles.badge}>{LABELS[value] || value}</span>
)

export default MicrositePlacementBadge